import { AllocationDetailsPanel } from '../../../sites/components/panel/organisms/AllocationDetailsPanel';

interface AllocationDrawerContentProps {
  allocationId: string;
  onAdminCancel?: (allocationId: string) => void;
}

export function AllocationDrawerContent({
  allocationId,
  onAdminCancel,
}: AllocationDrawerContentProps) {
  return (
    <AllocationDetailsPanel
      allocationId={allocationId}
      onAdminCancel={onAdminCancel}
    />
  );
}
